'use strict';

var util = require('hast-util-raw');

module.exports = raw;

function raw() {
  return util;
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/rehype-raw/index.js
// module id = 1229
// module chunks = 0